import { render, staticRenderFns } from "./CustomerGroupName.vue?vue&type=template&id=1abfa96b&"
import script from "./CustomerGroupName.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports